import { useState, useEffect, useRef } from "react";
import debounce from "lodash.debounce";

export const useSearch = ({
  minLength = 2,
  delay = 500,
  onSearch,
  defaultQuery,
}) => {
  const [inputText, setInputText] = useState("");
  const [searchText, setSearchText] = useState("");
  const [tooShortWarning, setTooShortWarning] = useState(false);

  const setSearchTextDebounced = useRef(
    debounce((value) => setSearchText(value), delay)
  ).current;

  const handleInputChange = (value, event) => {
    if (event?.action !== "input-blur" && event?.action !== "menu-close") {
      setInputText(value);
      setSearchTextDebounced(value);
    }
  };

  useEffect(() => {
    if (searchText.length >= minLength) {
      setTooShortWarning(false);
      onSearch(searchText);
    } else {
      if (searchText.length > 0) {
        setTooShortWarning(true);
      } else {
        setTooShortWarning(false);
        setInputText("");
        setSearchText("");
        onSearch(""); // Default search/reset behavior
      }
    }
  }, [searchText, onSearch, minLength]);

  return {
    inputText,
    setInputText,
    handleInputChange,
    tooShortWarning,
  };
};
